import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import DesktopCategories from './desktop';
import MobileCategories from './mobile';
import { useVideosFilterContext } from '../../context';
interface Props {
  mode: 'mobile' | 'desktop';
}
const CategoryFilter = ({
  mode
}: Props) => {
  const {
    isMobile
  } = useMobileDetect();
  const {
    isCategoriesLoading
  } = useVideosFilterContext();
  if (isMobile && mode === 'mobile') {
    return <MobileCategories />;
  }
  if (!isMobile && mode !== 'desktop') return null;
  if (isCategoriesLoading) {
    return <div className='hidden h-80 w-[221px] shrink-0 animate-pulse rounded bg-gray-100 lg:block' />;
  }
  return <DesktopCategories data-sentry-element="DesktopCategories" data-sentry-component="CategoryFilter" data-sentry-source-file="index.tsx" />;
};
export default CategoryFilter;